import axios from 'axios';
import { GetGaUserCode, GetUserIdCookie } from '../commom/userCode';
import { getAuthToken } from '../commom/authToken';

const axiosInstancePlano = axios.create({
    baseURL: process.env.REACT_APP_PLANO_ADAPTATIVO_API,
});

axiosInstancePlano.interceptors.request.use(
    (config) => {
        const token = getAuthToken();

        if(token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        if (config.method === 'post') {
            config.data = {
                ...config.data,
                uniqueGaId: GetGaUserCode(),
                userIdCookie: GetUserIdCookie(),
            };
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

const axiosInstanceMiddleare = axios.create({
    baseURL: process.env.REACT_APP_PLANO_ADAPTATIVO_MIDDLEWARE,
});

axiosInstanceMiddleare.interceptors.request.use(
    (config) => {
        const token = getAuthToken();

        config.headers['Content-Type'] = 'application/json';

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => {
        console.log(error)
        return Promise.reject(error);
    }
);

export { axiosInstancePlano, axiosInstanceMiddleare };

